import css from "styled-jsx/css";

export default css`
  .cerberus__fake {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    &--box {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      &--title {
        height: 26px;
        width: 20%;
      }
      &--switch {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        padding: 1rem 0;
        border-bottom: 1px solid #f3eeea;
        &--info {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          width: 80%;
          &--label {
            height: 18px;
            width: 80px;
          }
          &--text {
            height: 18px;
            width: 90%;
          }
        }
      }
      &--switch:last-child {
        border-bottom: 0;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .cerberus__fake {
      width: 60%;
    }
  }
`;
